module.exports = __webpack_public_path__ + "img/map-menu-4@2x.c964d16a.png";